module.exports = __webpack_public_path__ + "static/img/zzry.557f3ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/aboutPage/zzry.jpg
// module id = 6lNW
// module chunks = 14